/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Perspective } from '../model';
// @ts-ignore
import { PerspectiveEntitySummary } from '../model';
/**
 * SharedApi - axios parameter creator
 * @export
 */
export const SharedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create perspective
         * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPerspective: async (perspective: Perspective, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('createPerspective', 'perspective', perspective)
            const localVarPath = `/shared/perspective/perspectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a temporary perspective
         * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemporaryPerspective: async (perspective: Perspective, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('createTemporaryPerspective', 'perspective', perspective)
            const localVarPath = `/shared/perspective/perspectives/temporary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete perspective
         * @param {number} id ID of perspective to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerspective: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePerspective', 'id', id)
            const localVarPath = `/shared/perspective/perspectives/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets specified perspective.
         * @param {number} id perspective ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerspective: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPerspective', 'id', id)
            const localVarPath = `/shared/perspective/perspectives/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all perspectives in org.
         * @summary Gets all accessible perspectives.
         * @param {number} [entityType] optional entityType ID to restrict to specified entity type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerspectives: async (entityType?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/shared/perspective/perspectives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates perspective to be primary or not primary for the user and entity type
         * @param {number} id ID of perspective to set as primary or not primary
         * @param {boolean} body whether Perspective should be primary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPerspectiveAsPrimary: async (id: number, body: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setPerspectiveAsPrimary', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setPerspectiveAsPrimary', 'body', body)
            const localVarPath = `/shared/perspective/perspectives/{id}/primary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update perspective
         * @param {number} id ID of perspective to update; must match &#x60;id&#x60; in request body
         * @param {Perspective} perspective desired value of Perspective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerspective: async (id: number, perspective: Perspective, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePerspective', 'id', id)
            // verify required parameter 'perspective' is not null or undefined
            assertParamExists('updatePerspective', 'perspective', perspective)
            const localVarPath = `/shared/perspective/perspectives/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(perspective, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SharedApi - functional programming interface
 * @export
 */
export const SharedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SharedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create perspective
         * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPerspective(perspective: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Perspective>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPerspective(perspective, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a temporary perspective
         * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemporaryPerspective(perspective: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PerspectiveEntitySummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemporaryPerspective(perspective, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete perspective
         * @param {number} id ID of perspective to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePerspective(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePerspective(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets specified perspective.
         * @param {number} id perspective ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerspective(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Perspective>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerspective(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets all perspectives in org.
         * @summary Gets all accessible perspectives.
         * @param {number} [entityType] optional entityType ID to restrict to specified entity type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerspectives(entityType?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Perspective>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerspectives(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates perspective to be primary or not primary for the user and entity type
         * @param {number} id ID of perspective to set as primary or not primary
         * @param {boolean} body whether Perspective should be primary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPerspectiveAsPrimary(id: number, body: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Perspective>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPerspectiveAsPrimary(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update perspective
         * @param {number} id ID of perspective to update; must match &#x60;id&#x60; in request body
         * @param {Perspective} perspective desired value of Perspective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePerspective(id: number, perspective: Perspective, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Perspective>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePerspective(id, perspective, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SharedApi - factory interface
 * @export
 */
export const SharedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SharedApiFp(configuration)
    return {
        /**
         * 
         * @summary Create perspective
         * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPerspective(perspective: Perspective, options?: any): AxiosPromise<Perspective> {
            return localVarFp.createPerspective(perspective, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a temporary perspective
         * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemporaryPerspective(perspective: Perspective, options?: any): AxiosPromise<PerspectiveEntitySummary> {
            return localVarFp.createTemporaryPerspective(perspective, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete perspective
         * @param {number} id ID of perspective to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerspective(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deletePerspective(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets specified perspective.
         * @param {number} id perspective ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerspective(id: number, options?: any): AxiosPromise<Perspective> {
            return localVarFp.getPerspective(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all perspectives in org.
         * @summary Gets all accessible perspectives.
         * @param {number} [entityType] optional entityType ID to restrict to specified entity type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerspectives(entityType?: number, options?: any): AxiosPromise<Array<Perspective>> {
            return localVarFp.getPerspectives(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates perspective to be primary or not primary for the user and entity type
         * @param {number} id ID of perspective to set as primary or not primary
         * @param {boolean} body whether Perspective should be primary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPerspectiveAsPrimary(id: number, body: boolean, options?: any): AxiosPromise<Perspective> {
            return localVarFp.setPerspectiveAsPrimary(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update perspective
         * @param {number} id ID of perspective to update; must match &#x60;id&#x60; in request body
         * @param {Perspective} perspective desired value of Perspective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerspective(id: number, perspective: Perspective, options?: any): AxiosPromise<Perspective> {
            return localVarFp.updatePerspective(id, perspective, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SharedApi - object-oriented interface
 * @export
 * @class SharedApi
 * @extends {BaseAPI}
 */
export class SharedApi extends BaseAPI {
    /**
     * 
     * @summary Create perspective
     * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedApi
     */
    public createPerspective(perspective: Perspective, options?: any) {
        return SharedApiFp(this.configuration).createPerspective(perspective, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a temporary perspective
     * @param {Perspective} perspective Perspective to create; &#x60;id&#x60; must be absent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedApi
     */
    public createTemporaryPerspective(perspective: Perspective, options?: any) {
        return SharedApiFp(this.configuration).createTemporaryPerspective(perspective, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete perspective
     * @param {number} id ID of perspective to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedApi
     */
    public deletePerspective(id: number, options?: any) {
        return SharedApiFp(this.configuration).deletePerspective(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets specified perspective.
     * @param {number} id perspective ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedApi
     */
    public getPerspective(id: number, options?: any) {
        return SharedApiFp(this.configuration).getPerspective(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets all perspectives in org.
     * @summary Gets all accessible perspectives.
     * @param {number} [entityType] optional entityType ID to restrict to specified entity type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedApi
     */
    public getPerspectives(entityType?: number, options?: any) {
        return SharedApiFp(this.configuration).getPerspectives(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates perspective to be primary or not primary for the user and entity type
     * @param {number} id ID of perspective to set as primary or not primary
     * @param {boolean} body whether Perspective should be primary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedApi
     */
    public setPerspectiveAsPrimary(id: number, body: boolean, options?: any) {
        return SharedApiFp(this.configuration).setPerspectiveAsPrimary(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update perspective
     * @param {number} id ID of perspective to update; must match &#x60;id&#x60; in request body
     * @param {Perspective} perspective desired value of Perspective
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedApi
     */
    public updatePerspective(id: number, perspective: Perspective, options?: any) {
        return SharedApiFp(this.configuration).updatePerspective(id, perspective, options).then((request) => request(this.axios, this.basePath));
    }
}
